module.exports = __webpack_public_path__ + "static/media/Logo_NAS 2-10.a38cd55c.svg";